export default __webpack_public_path__ + "static/media/ecosystem.2b5a63ef.png";